import { doubleRAF } from '@ga/shared-browser'
import gsap from '@ga/shared-gsap'

export default {
  name: 'ga-splash-screen',

  emits: ['close'],

  setup(_, { emit }) {
    const { $gaApp } = useNuxtApp()

    const playedOnce = ref(false)
    const containerRef = useTemplateRef('containerRef')

    const videoSource = computed(() => $gaApp.services.main.sources.splash)
    const isAllSourcesLoaded = computed(
      () => $gaApp.services.main.sources.isAllLoaded,
    )

    // скрытие компонента с анимацией
    const closeSplash = () => {
      gsap.to(containerRef.value, {
        autoAlpha: 0,
        duration: 0.5,
        scale: 1.05,
        // force3D: true,
        onComplete: () => {
          emit('close')
        },
      })
    }

    onMounted(() => {
      // если не было загружено, то скрываем компонент
      if (!videoSource.value) {
        return emit('close')
      }

      const cachedVideo = videoSource.value

      // настраиваем видео для автовоспроизведения без контролов
      cachedVideo.playsInline = true
      cachedVideo.muted = true
      cachedVideo.controls = false

      cachedVideo.addEventListener('ended', () => {
        try {
          if (!playedOnce.value) {
            playedOnce.value = true
          }
          cachedVideo.currentTime = 0
          cachedVideo.play()
        } catch (error) {
          console.error(`Ошибка воспроизведения видео: ${error}`)
        }
      })

      // убедившись, что видео играет, отписываемся и выводим содержимое
      let hasStartedPlaying = false

      const onTimeUpdate = () => {
        if (cachedVideo.currentTime > 0 && !hasStartedPlaying) {
          hasStartedPlaying = true
          cachedVideo.removeEventListener('timeupdate', onTimeUpdate)
          cachedVideo.removeEventListener('playing', onPlaying)

          doubleRAF(() => {
            cachedVideo.style.display = ''
          })
        }
      }

      const onPlaying = () => {
        // начинаем слушать timeupdate для проверки, что видео действительно играет
        cachedVideo.addEventListener('timeupdate', onTimeUpdate)
      }

      cachedVideo.addEventListener('playing', onPlaying)

      // добавляем видео в DOM, но скрываем его до начала воспроизведения
      containerRef.value.appendChild(cachedVideo)
      cachedVideo.style.display = 'none'

      cachedVideo.play().catch((error) => {
        cachedVideo.removeEventListener('playing', onPlaying)

        console.error(`Ошибка запуска видео: ${error}`)
        const debug = new Error('Ошибка запуска splash видео')
        debug.data = JSON.stringify(error)
        debug.customName = 'splash:video-play'
        $gaApp.services.app.apm.captureError(debug)

        emit('close')
      })

      // следи за проигрыванием
      // если ресурсы загружены и видео проиграно, то скрываем компонент
      watch(playedOnce, (value) => {
        if (value && isAllSourcesLoaded.value) {
          closeSplash()
        }
      })

      // следи за загрузкой ресурсов
      // если ресурсы загружены и видео проиграно, то скрываем компонент
      watch(isAllSourcesLoaded, (value) => {
        if (value && playedOnce.value) {
          nextTick(() => {
            closeSplash()
          })
        }
      })
    })

    return { containerRef }
  },
}
